import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'motion/react';
import { useLanguage } from '../context/LanguageContext';
import { SPRING_DEFAULT, REDUCED_MOTION_TRANSITION } from '../utils/springs';
import './Hero.css';

const Hero = () => {
  const { t } = useLanguage();
  const reduceMotion = useReducedMotion();
  const transition = reduceMotion ? REDUCED_MOTION_TRANSITION : SPRING_DEFAULT;

  return (
    <section className="hero">
      <div className="hero-slide">
        <motion.div
          className="hero-content"
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 24 }}
          animate={reduceMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
          transition={transition}
        >
          <div className="hero-copy">
            <p className="hero-tagline">{t('hero.tagline')}</p>
            <h1 className="hero-headline">{t('hero.mainTitle')}</h1>
            <p className="hero-description">{t('hero.description')}</p>
            <motion.div whileTap={reduceMotion ? undefined : { scale: 0.97 }}>
              <Link to="/products" className="hero-cta btn-primary">
                {t('hero.cta')}
              </Link>
            </motion.div>
          </div>
          <div className="hero-products">
            <div className="hero-product-can">
              <img
                src="/images/products/hazelnuts/jute-10kg.png"
                alt={t('hero.premiumHazelnutsAlt')}
                className="hero-product-img"
                loading="eager"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
